import { generatePath } from "react-router-dom"
import { platformApi } from "./axiosConfig"
import * as Constants from "../../constants/apis"

export const UserAPI = {
  getStats: async function () {
    const response = await platformApi.request({
      url: Constants.GET_USER_STATS,
      method: Constants.GET,
    })

    return response.data
  },
  certifyAll: async function (service: string) {
    const response = await platformApi.request({
      url: Constants.CERTIFY_ALL,
      method: Constants.PATCH,
      headers: { "Comixtime-Service": service },
    })

    return response.data
  },
  getComicCollectors: async function (id: number, status: number) {
    const response = await platformApi.request({
      url: generatePath(Constants.GET_COMIC_COLLECTORS, { id: id.toString() }),
      method: Constants.GET,
      params: { status: status },
    })

    return response.data
  },
}
